// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SellerReviews__selfBlocked":"hk_a bhs_cw bhs_tu bhs_sm bhs_ug bhs_ua"};